/* import __COLOCATED_TEMPLATE__ from './dds-settings.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { numberToUserDisplay } from '@ebiz/pretty-num';
import type Intl from 'ember-intl/services/intl';
import type CircuitService from '../services/circuit';

import { sigFigsDown } from '../utils';

interface DDSSettingsSignature {
  Args: { productChanged: () => void };
}
export default class DDSSettingsPanel extends Component<DDSSettingsSignature> {
  @service declare intl: Intl;
  @service declare circuit: CircuitService;

  displayFormat = 'Engineering';
  significantDigits = 8;
  get maxSysClkMessage() {
    return this.intl.t('dds.message_max_sys_clk', {
      device: this.circuit.partNumber,
      frequency: numberToUserDisplay(this.circuit.maxClock, this.displayFormat, this.significantDigits, {
        showZeroes: false,
      }),
      units: this.intl.t('hertz_unit'),
    });
  }
  get maxInputClkMultipleMessage() {
    return this.intl.t('dds.message_max_inp_clk_multi', {
      multiplier: this.circuit.multiplier,
      frequency: numberToUserDisplay(this.circuit.minClock, this.displayFormat, this.significantDigits, {
        showZeroes: false,
      }),
      units: this.intl.t('hertz_unit'),
    });
  }
  get nyquistFreqMessage() {
    return this.intl.t('dds.message_nyquist_freq', {
      frequency: numberToUserDisplay(
        sigFigsDown(this.circuit.nyquistFreq, 8),
        this.displayFormat,
        this.significantDigits,
        {
          showZeroes: false,
        },
      ),
      units: this.intl.t('hertz_unit'),
    });
  }
  get isMessageLengthMoreThanOneLine() {
    return this.maxSysClkMessage.length > 43 || this.maxInputClkMultipleMessage.length > 43;
  }
  @action onClockInputChanged(value: number) {
    this.circuit.clockInput = value;
  }
  @action onFrequencyChanged(value: number) {
    this.circuit.targetFrequency = value;
  }
  @action onSystemClockChanged(value: number) {
    this.circuit.systemClock = value;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DdsSettings: typeof DDSSettingsPanel;
  }
}
